// ABOUTME: Small plus icon for add actions in workout constructor
// ABOUTME: Supports className, size, and color customization

interface PlusSmallIconProps {
  className?: string
  size?: number
  color?: string
}

export const PlusSmallIcon = ({ className = "", size = 14, color = "black" }: PlusSmallIconProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.4688 7C12.4688 7.17405 12.3996 7.34097 12.2765 7.46404C12.1535 7.58711 11.9865 7.65625 11.8125 7.65625H7.65625V11.8125C7.65625 11.9865 7.58711 12.1535 7.46404 12.2765C7.34097 12.3996 7.17405 12.4688 7 12.4688C6.82595 12.4688 6.65903 12.3996 6.53596 12.2765C6.41289 12.1535 6.34375 11.9865 6.34375 11.8125V7.65625H2.1875C2.01345 7.65625 1.84653 7.58711 1.72346 7.46404C1.60039 7.34097 1.53125 7.17405 1.53125 7C1.53125 6.82595 1.60039 6.65903 1.72346 6.53596C1.84653 6.41289 2.01345 6.34375 2.1875 6.34375H6.34375V2.1875C6.34375 2.01345 6.41289 1.84653 6.53596 1.72346C6.65903 1.60039 6.82595 1.53125 7 1.53125C7.17405 1.53125 7.34097 1.60039 7.46404 1.72346C7.58711 1.84653 7.65625 2.01345 7.65625 2.1875V6.34375H11.8125C11.9865 6.34375 12.1535 6.41289 12.2765 6.53596C12.3996 6.65903 12.4688 6.82595 12.4688 7Z"
      fill={color}
    />
  </svg>
)
